import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import MessageUI from '../../../widgets/output/MessageUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import ButtonUI from '../../../widgets/action/ButtonUI'
import ErrorMessageUI from '../../../widgets/form/ErrorMessageUI'
import SuccessMessageUI from '../../../widgets/form/SuccessMessageUI'
import CreditCardNoneUI from './CreditCardNoneUI'
import CreditCardViewUI from './CreditCardViewUI'
import CreditCardCreateUI from './CreditCardCreateUI'
import './PaymentSettingsView.css'

const PaymentSettingsViewUI = ({context, messageList, paymentMethodList, stripeApiKey,
    createOrUpdateMode, onCreateOrUpdateClick, onCancelCreateOrUpdateClick,
    cancelMode, onCancelClick, onCancelCancelClick, onCancelSubmit, cancelSubmitted, errorList, successMsg,
    onPaymentSettingsChange}) =>
  <React.Fragment>
    {
      /* update mode */
      createOrUpdateMode &&
      <CreditCardCreateUI
        context={context}
        paymentMethodCard={paymentMethodList.length ? paymentMethodList[0] : null}
        stripeApiKey={stripeApiKey}
        messageList={messageList}
        onCancelCreateOrUpdateClick={onCancelCreateOrUpdateClick}
        onPaymentSettingsChange={onPaymentSettingsChange}
      />
    }

    {
      /* no card view mode */
      !createOrUpdateMode && !paymentMethodList.length &&
      <CardUI className='acc_ps_v'>
        <CreditCardNoneUI  contet={context} messageList={messageList} />
        <div className='g_flex_h actions'>
          <span />
          <ButtonUI
            messageList={messageList}
            labelKey='c_add_card'
            transparent={true}
            onClick={onCreateOrUpdateClick} />
        </div>
      </CardUI>
    }

    {
      !createOrUpdateMode && paymentMethodList.length > 0 &&
      <CardUI className='acc_ps_v'>
        <SuccessMessageUI className='msg' successMsg={successMsg} />
        <ErrorMessageUI className='msg' errorList={errorList} />

        <CreditCardViewUI context={context} messageList={messageList} paymentMethodCard={paymentMethodList[0].card} />

        {
          /* update and cancel buttons */
          !createOrUpdateMode && !cancelMode &&
          <div className='g_flex_h actions'>
            <ButtonUI
              messageList={messageList}
              labelKey='c_update_card'
              transparent={true}
              onClick={onCreateOrUpdateClick} />
            <ButtonUI
              messageList={messageList}
              labelKey='c_remove_card'
              transparent={true}
              onClick={onCancelClick} />
          </div>
        }

        {
          /* cancel mode */
          cancelMode &&
          <div className='actions g_text_right'>
            <MessageUI messageList={messageList} messageKey='c_remove_card_confirm' />
            <div className='g_flex_h actions cancel'>
              <ButtonUI
                messageList={messageList}
                labelKey='c_do_not_remove'
                transparent={true}
                onClick={onCancelCancelClick} />
              <SpinnerUI show={cancelSubmitted} />
              <ButtonUI
                messageList={messageList}
                labelKey='c_yes_remove'
                onClick={onCancelSubmit}
                disabled={cancelSubmitted} />
            </div>
          </div>
        }
      </CardUI>
    }
  </React.Fragment>

export default PaymentSettingsViewUI
